/* eslint-disable no-throw-literal */
import intersection from 'lodash/intersection';
import store from '../store';

export default function space_permission(action, space = null) {
    /* Check the access to space by action. eg: SPACE_UPDATE */
    const current_space = space || store.state.spaces.detail.data;
    if (!current_space) {
        throw 'You can use this function only in space content or with space argument!';
    }

    const { space_permissions } = store.state.configurations;

    if (!Object.prototype.hasOwnProperty.call(space_permissions, action)) {
        global.console.error('Action is not found (store.state.configurations.space_permissions)!');
        return null;
    }

    const roles = space_permissions[action];
    return intersection(current_space.roles, roles).length > 0;
}
